import { mutations } from './mutations';
import { queries } from './queries';
import { subscriptions } from './subscriptions';

const mocks = [...queries, ...mutations, ...subscriptions];

export default mocks;
